import { useState } from "react";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";

export default function HelpfulButton({ review }) {
  const { user } = useAuth();
  const [count, setCount] = useState(review.helpful_count || 0);
  const [marked, setMarked] = useState(!!review.helpful_by_me);
  const [loading, setLoading] = useState(false);

  const vote = async () => {
    if (!user) {
      toast.error("Connectez-vous pour marquer un avis comme utile");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post(`/reviews/${review.id}/helpful`);
      setCount(data.helpful_count);
      setMarked(data.marked);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={`review-helpful-btn-${review.id}`}
      onClick={vote}
      disabled={loading}
      aria-pressed={marked}
      title={marked ? "Vous avez trouvé cet avis utile" : "Cet avis vous a-t-il été utile ?"}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors duration-200 disabled:opacity-60 ${
        marked
          ? "border-brand bg-brand-soft text-brand"
          : "border-line text-slate-500 hover:border-brand hover:text-brand"
      }`}
    >
      <ThumbsUp className="h-3.5 w-3.5" fill={marked ? "currentColor" : "none"} />
      Utile
      {count > 0 && (
        <span data-testid={`review-helpful-count-${review.id}`} className="tabular-nums">
          · {count}
        </span>
      )}
    </button>
  );
}
